export default "__VITE_ASSET__Ceqr6lHp__"